var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"has-text-centered has-text-weight-bold title"},[_vm._v("Upload Document")]),_c('upload-component',{attrs:{"documentId":_vm.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }